import { render, staticRenderFns } from "./AlarmModule.vue?vue&type=template&id=224e3730"
import script from "./AlarmModule.vue?vue&type=script&lang=js"
export * from "./AlarmModule.vue?vue&type=script&lang=js"
import style0 from "./AlarmModule.vue?vue&type=style&index=0&id=224e3730&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports